module.exports = __webpack_public_path__ + "img/game-disabled.9475cc3c.png";